

export const InfoTable = ({ title, data, statusInfo }) => {
    if (!statusInfo) return null;

    return (
      <>
        <h6 className="fw-bold text-muted">{title}</h6>
        <table className="table main-background">
          <tbody>
            {data.map(({ label, key }) => (
              <tr key={key} className="text-start">
                <td><strong className="text-muted">{label}</strong></td>
                <td className="text-end text-muted">
                  {statusInfo[key] || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  export const InfoTableRows = ({ data, statusInfo }) => {
  if (!statusInfo) return null;
  
  return (
    <>
      {data.map(({ label, key }) => (
        <tr key={key} className="text-start">
          <td><strong className="text-muted">{label}</strong></td>
          <td className="text-end text-muted">
            {statusInfo[key] || "-"}
          </td>
        </tr>
      ))}
    </>
  );
};